export const handleMenuClick = (event, setAnchorEl) => { setAnchorEl(event.currentTarget) };
export const handleMenuClose = (setAnchorEl) => { setAnchorEl(null) };
export const handleOpenBottomSheet = (setIsBottomSheetOpen) => { setIsBottomSheetOpen(true) };
export const handleCloseBottomSheet = (setIsBottomSheetOpen) => { setIsBottomSheetOpen(false) };

//TODO: Search for all instances of handleOpen and handleClose, replace with these.